import { shouldRetryRequest } from 'src/utils/requestError';

/**
 * The rules every query on the storefront lives by unless its hook says otherwise. The one
 * QueryClient of the app is built from them (`main.tsx`) — and so is the client of a spec that
 * mounts a hook, less the retry: on the library's own defaults everything is stale at once, and a
 * hook that forgot to say how fresh its answer has to be passes its test all the same.
 */
export const QUERY_DEFAULTS = {
  refetchOnWindowFocus: false,
  staleTime: Infinity,
  // A 4xx is never re-asked and everything else at most once — the default three retries
  // with back-off kept a delisted car "loading" for seven seconds before saying it was gone.
  retry: shouldRetryRequest,
};
